export const REQUEST_TANKS_DATA = 'REQUEST_TANKS_DATA';
export const TANK_SELECTED = 'TANK_SELECTED';
export const GET_TANKS = 'GET_TANKS';
export const CREATE_TANK = 'CREATE_TANK';
export const MOD_TANK = 'MOD_TANK';
export const GET_TANKS_SUPPLY_PERMIT = 'GET_TANK_SUPPLY_PERMIT';
export const CREATE_TANK_SUPPLY_PERMIT = 'CREATE_TANK_SUPPLY_PERMIT';
export const CHECK_UNIT_SUPPLY_PERMIT = 'CHECK_UNIT_SUPPLY_PERMIT';
export const DELETE_TANK_SUPPLY_PERMIT = 'DELETE_TANK_SUPPLY_PERMIT';
export const RESET_SUCCESS = 'RESET_SUCCESS';
export const RESET_TANK_SELECTED = 'RESET_TANK_SELECTED';
export const ADD_TANK_MODE = 'ADD_TANK_MODE';
export const EDIT_TANK_MODE = 'EDIT_TANK_MODE';
export const SET_ERROR = 'SET_ERROR';
export const CLEAN_ERROR = 'CLEAN_ERROR';
export const RESET_LOADING = 'RESET_LOADING';
export const TANK_ASSIGNED = 'TANK_ASSIGNED';
export const REMOVE_TANK_ASSIGNED = 'REMOVE_TANK_ASSIGNED';
export const OPEN_MODAL_ASSIGN = 'OPEN_MODAL_ASSIGN';
export const CLOSE_MODAL_ASSIGN = 'CLOSE_MODAL_ASSIGN';
export const REMOVE_TANK_SUPPLY_PERMIT = "REMOVE_TANK_SUPPLY_PERMIT"
const initialState = {
  tanks: {},
  tanksArr: [],
  tankSelected: null,
  permitSupplies: {},
  permitSuppliesArr: [],
  checkUnitSupplyPermit: false,
  loading: false,
  dataSuccess: false,
  messageSuccess: '',
  addMode: false, 
  error: false,
  errorMessage: '',
  selectUnitToAssing: {},
  modalAssingTank: false
}

const toArray = (data) => {
  return Object.keys(data).map(id => {
    return data[id]
  })
}
const toObject = (data) => {
  return data.reduce((acc, curr) => {
    acc[curr.id || curr.id_unit] = curr
    return acc
  }, {})
}


export const tanksReducer = (state = initialState, action) => {
  switch (action.type) {

    case REQUEST_TANKS_DATA:
      return {
        ...state,
        loading: true
      }
    case ADD_TANK_MODE:
      return {
        ...state,
        addMode: true
      }
    case EDIT_TANK_MODE:
      return {
        ...state,
        addMode: false
      }
    case GET_TANKS:
      if (!Array.isArray(action.payload)) return state;
      const filteredTanks = action.payload.filter(tank => tank?.name?.length > 0)
      const listTanks = toObject(filteredTanks)
      return {
        ...state,
        tanks: listTanks,
        tanksArr: filteredTanks,
        loading: false,
      }
    case TANK_ASSIGNED:
      const strState = JSON.stringify(state)
      const newState = JSON.parse(strState)
      
      action.payload.map(id => {
        newState.tanks[id].assigned = 1
        return null
      })
      return {
        ...newState
      }
    case REMOVE_TANK_ASSIGNED:
    case TANK_SELECTED:
      return {
        ...state,
        tankSelected: action.payload && state.tanks[action.payload]
      }
    case RESET_TANK_SELECTED:
      return {
        ...state,
        tankSelected: null
      }

    case CREATE_TANK:
      const dataArr = toArray(state.tanks)
      const addingTank =[action.payload, ...dataArr ]
      const newTanks = toObject(addingTank)
      return {
        ...state,
        tanks: newTanks,
        tanksArr: addingTank,
        loading: false,
        messageSuccess: 'Tanque creado',
        dataSuccess: true
      }

    case MOD_TANK:
      return {
        ...state,
        tanks: {
          ...state.tanks,
          [action.payload.id]: {
            ...state.tanks[action.payload.id],
            ...action.payload
          },
        },
        loading: false,
        dataSuccess: true,
        messageSuccess: 'Tanque modificado con exíto'
      }

    case GET_TANKS_SUPPLY_PERMIT:
      return {
        ...state,
        permitSupplies: toObject(action.payload),
        permitSuppliesArr: action.payload,
        loading: false,
      }

    case CREATE_TANK_SUPPLY_PERMIT:
    const supplyArr = toArray(state.tanks)
    const addingPermit =[action.payload, ...supplyArr ]
    const newSupply = toObject(addingPermit)
    return {
      ...state,
      permitSupplies: newSupply,
      permitSuppliesArr: addingPermit,
      loading: false,
      dataSuccess: true,
      messageSuccess: 'Permisos Creados'
    }
    
    case DELETE_TANK_SUPPLY_PERMIT:
      state.tanks[action.payload] = {
        ...state.tanks[action.payload],
        assigned: 0
      }
      return {
        ...state,
        tanksArr: toArray(state.tanks)
      }
    case CHECK_UNIT_SUPPLY_PERMIT:
    
    return {
      ...state,
      checkUnitSupplyPermit: action.payload,
      loading: false,
    }

    case RESET_SUCCESS:
      return {
        ...state,
        dataSuccess: false
      }

    case SET_ERROR:
      return {
        ...state,
        error: true,
        errorMessage: action.payload
      }
    case OPEN_MODAL_ASSIGN:
      return {
        ...state,
        selectUnitToAssing: action.payload,
        modalAssingTank: true
      }
      case CLOSE_MODAL_ASSIGN:
        return {
          ...state,
        selectUnitToAssing: {},
        modalAssingTank: false
      }
    case CLEAN_ERROR:
      return {
        ...state,
        error: false,
        errorMessage: ''
      }
    case RESET_LOADING:
      return {
        ...state,
        loading: false
      }
    default :
      return state
  }
}